import { ConfigProvider, theme } from 'antd';
import { ReactNode } from 'react';
import useDeviceInfo from './device-info';

interface Props {
  children: ReactNode;
}

export const AppThemeProvider: React.FC<Props> = (props) => {
  const { children } = props;

  const { isDesktopOrLaptop, isDL } = useDeviceInfo();

  return (
    <ConfigProvider
      theme={{
        algorithm: theme?.compactAlgorithm,
        token: {
          fontFamily: 'Poppins',
        },
        components: {
          Form: {
            labelColor: '#1e1e1ecc',
            labelFontSize: 12,
            itemMarginBottom: 10,
            fontSize: isDesktopOrLaptop ? 13 : 11,
          },

          Button: {
            controlHeight: isDesktopOrLaptop ? 32 : 28,
          },

          Table: {
            cellPaddingInline: 2,
            cellPaddingBlock: isDL ? 4 : 6,
            borderColor: '#12a36cc2',
            headerBg: '#12a36cc2',
            headerColor: '#fff',
            // fontWeightStrong: 700,
            fontWeightStrong: 600,
            fontSize: isDL ? 10 : 13,
            headerSortActiveBg: '',
            headerSortHoverBg: '',
            // fontFamily: 'Poppins',
          },
          Menu: {
            itemMarginBlock: 6,
          },

          Drawer: {
            padding: 20,
          },

          Select: {
            controlHeight: isDL ? 24 : isDesktopOrLaptop ? 30 : 28,
          },
          Input: {
            controlHeight: isDesktopOrLaptop ? 30 : 28,
          },
          DatePicker: {
            controlHeight: isDesktopOrLaptop ? 30 : 28,
            colorBgContainerDisabled: 'rgba(0,0,0,0.04)',
            colorTextDisabled: '#000000',
          },
          Checkbox: {
            colorPrimary: 'rgba(24, 151, 102, 0.76)',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
